/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-add': {
    width: 6,
    height: 7,
    viewBox: '0 0 6 7',
    data: '<path pid="0" _fill="#376F99" fill-rule="nonzero" d="M3.56.316H2.441v2.417l-2.42.002.002 1.117H2.44v2.417l1.117.001.002-2.419h2.418l-.002-1.117H3.56z"/>'
  }
})
